// type-coverage:ignore-next-line
import { DestroyRef, ElementRef, inject, signal, Directive } from '@angular/core';
import { fromEvent } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export abstract class ScrollComponent {
    public readonly document = inject(DOCUMENT);
    private readonly destroyRef = inject(DestroyRef);

    public activeId = signal<number>(0);

    public isInViewport(elm: HTMLElement): boolean {
        const elementTop = elm.offsetTop;
        const elementBottom = elementTop + elm.offsetHeight;

        const viewportTop = this.document.documentElement.scrollTop;
        const viewportBottom = viewportTop + this.document.documentElement.clientHeight;

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    public onScroll(cards: readonly ElementRef<HTMLElement>[]): void {
        fromEvent(this.document, 'scroll')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                const scrollIdCardId = cards.find((e) => this.isInViewport(e.nativeElement))
                    ?.nativeElement.id;
                if (scrollIdCardId) {
                    this.changeActiveId(Number(scrollIdCardId));
                }
            });
    }

    public anchorScroll(
        id: number,
        slides: readonly ElementRef<HTMLElement>[],
        position: 'center' | 'start' = 'center'
    ): void {
        const item = slides?.[id];
        if (item) {
            item.nativeElement.scrollIntoView({ behavior: 'smooth', block: position });
        }
    }

    public changeActiveId(id: number): void {
        this.activeId.set(id);
    }
}
